export const formatFrozenValue = (value) => {
  if (value === undefined || value === null) return "";
  if (typeof value === "string") return value;
  if (typeof value === "number" || typeof value === "boolean") {
    return String(value);
  }
  return JSON.stringify(value);
};

export const parseFrozenValue = (raw) => {
  if (raw === undefined || raw === null) return undefined;
  const trimmed = String(raw).trim();
  if (trimmed === "") return undefined;
  if (trimmed === "true") return true;
  if (trimmed === "false") return false;
  if (/^-?\d+$/.test(trimmed) || /^-?\d+\.\d+$/.test(trimmed)) {
    const asNumber = Number(trimmed);
    if (Number.isFinite(asNumber) && String(asNumber) === trimmed) {
      return asNumber;
    }
  }
  return trimmed;
};

export const mergeMappingRow = (row, patch) => {
  const next = { ...row, ...patch };
  if (
    Object.prototype.hasOwnProperty.call(patch, "value") &&
    (patch.value === undefined || patch.value === "")
  ) {
    delete next.value;
  }
  return next;
};
